var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1311 9.78258V13.8025M12.1311 17.8224H12.1412M10.4124 4.61719L1.90021 18.8275C1.72471 19.1315 1.63185 19.476 1.63087 19.827C1.62988 20.178 1.72081 20.5231 1.89461 20.828C2.06841 21.1329 2.31901 21.387 2.62149 21.5649C2.92397 21.7429 3.26778 21.8386 3.61872 21.8425H20.643C20.9939 21.8386 21.3377 21.7429 21.6402 21.5649C21.9427 21.387 22.1933 21.1329 22.3671 20.828C22.5409 20.5231 22.6318 20.178 22.6309 19.827C22.6299 19.476 22.537 19.1315 22.3615 18.8275L13.8494 4.61719C13.6702 4.32184 13.418 4.07764 13.1169 3.90817C12.8159 3.73869 12.4763 3.64966 12.1309 3.64966C11.7854 3.64966 11.4458 3.73869 11.1448 3.90817C10.8438 4.07764 10.5915 4.32184 10.4124 4.61719Z",
    stroke: "white",
    strokeWidth: 2.30432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertas);
export default __webpack_public_path__ + "static/media/Alertas.3099a6fb5d47d92b0ce08fcc630ad407.svg";
export { ForwardRef as ReactComponent };